<template>
    <notifications />
</template>

<script>
    export default {
        
    }
</script>